// Shared date formatting utility
// Postgres returns dates as "2026-03-24T00:00:00.000Z" — we just want "Mar 24, 2026"
export function fmtDate(val) {
  if (!val) return '—';
  // Take only the date part before any T to avoid timezone shift
  const parts = String(val).split('T')[0].split('-');
  if (parts.length !== 3) return val;
  const [y, m, d] = parts;
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${months[parseInt(m,10)-1]} ${parseInt(d,10)}, ${y}`;
}

// For <input type="date"> which needs YYYY-MM-DD
export function toInputDate(val) {
  if (!val) return '';
  return String(val).split('T')[0];
}

export function fmtMoney(val) {
  const n = Number(val);
  if (!val && val !== 0 || isNaN(n)) return '—';
  if (n >= 1e9) return `$${(n/1e9).toFixed(1).replace(/\.0$/,'')}B`;
  if (n >= 1e6) return `$${(n/1e6).toFixed(1).replace(/\.0$/,'')}M`;
  if (n >= 1e3) return `$${(n/1e3).toFixed(0)}K`;
  return `$${n.toLocaleString()}`;
}
